import { string, func } from 'prop-types'
import * as Higgs from '@opallabs/higgs'
import { MultiStepForm, MenuSection } from '@opallabs/kuiper'
import ConnectedPlacementCreator from '../PlacementCreator/connectedComponent'
import './styles.scss'

const placementsDescription =
  'Create placements on this page that pieces of content can be assigned to.'

const formatSecondaryTitle = (channelType, channelName, channelColor) => ({
  title: channelName,
  icon: `channel-${channelType}-14`,
  iconOptions: { style: { fill: channelColor, color: channelColor } },
})

const AccountSettings = ({
  accountId,
  accountName,
  channelColor,
  channelName,
  channelType,
  onPlacementChange,
  onSubmit,
}) => (
  <MultiStepForm
    className="account-settings"
    title={accountName}
    secondaryTitle={formatSecondaryTitle(
      channelType,
      channelName,
      channelColor
    )}
    submitText="Done"
    onSubmit={onSubmit}
  >
    <MenuSection
      customClassName="placement-creator-section"
      title="Placements"
      description={placementsDescription}
    >
      <Higgs.Provider>
        <ConnectedPlacementCreator
          accountId={accountId}
          onPlacementChange={onPlacementChange}
        />
      </Higgs.Provider>
    </MenuSection>
  </MultiStepForm>
)

AccountSettings.propTypes = {
  accountId: string,
  accountName: string,
  channelColor: string,
  channelName: string,
  channelType: string,
  onPlacementChange: func,
  onSubmit: func,
}

export default AccountSettings
